"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
import React, { useRef } from "react";
import { useOverlay } from "react-aria";
import { Calendar } from "./Calendar";
export const CalendarPopup = React.memo(function CalendarPopup({ datePickerState, calendarState, isOpen, onClose, colorPalette, }) {
    const popupRef = useRef(null);
    const { overlayProps } = useOverlay({
        isOpen,
        onClose,
        shouldCloseOnBlur: true,
        isDismissable: true,
        shouldCloseOnInteractOutside: (element) => {
            // Don't close if clicking on select components or their portals
            const selectElements = document.querySelectorAll('[data-scope="select"]');
            const portalElements = document.querySelectorAll('[data-part="positioner"]');
            for (const selectEl of selectElements) {
                if (selectEl.contains(element)) {
                    return false;
                }
            }
            for (const portalEl of portalElements) {
                if (portalEl.contains(element)) {
                    return false;
                }
            }
            return true;
        },
    }, popupRef);
    if (!isOpen)
        return null;
    return (_jsx(Box, { ref: popupRef, position: "absolute", top: "100%", left: 0, mt: 1, zIndex: 50, ...overlayProps, children: _jsx(Calendar, { datePickerState: datePickerState, calendarState: calendarState, colorPalette: colorPalette }) }));
});
